import { render } from "./SDKSetup.vue?vue&type=template&id=288cbf54"
import script from "./SDKSetup.vue?vue&type=script&lang=js"
export * from "./SDKSetup.vue?vue&type=script&lang=js"

import "./SDKSetup.vue?vue&type=style&index=0&id=288cbf54&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__